"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MilkRunMixin = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _elementUi = require("element-ui");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _route = require("@/api/route.api");

var _milkRun = require("@/api/milk-run.api");

var _plan = require("@/api/plan.api");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_TRUCK_WORKING_HOURS = [process.env.VUE_APP_DEFAULT_START_WORKINGHR, process.env.VUE_APP_DEFAULT_END_WORKINGHR];

var MilkRunMixin = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MilkRunMixin, _Mixins);

  var _super = _createSuper(MilkRunMixin);

  function MilkRunMixin() {
    var _this;

    (0, _classCallCheck2.default)(this, MilkRunMixin);
    _this = _super.apply(this, arguments);
    _this.openMapModal = false;
    _this.selectedTruckName = '';
    _this.selectedTruckData = [];
    _this.disableTruckKey = process.env.VUE_APP_DISABLE_TRUCK_KEY;
    _this.disableTruckList = [];
    _this.currentDate = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
    return _this;
  }

  (0, _createClass2.default)(MilkRunMixin, [{
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "$savedOrderIds",
    get: function get() {
      return this.$store.getters['milkRun/savedOrderIds'];
    },
    set: function set(newVal) {
      this.$setSavedOrderIds(newVal);
    }
  }, {
    key: "truckPlanIds",
    get: function get() {
      var truck = this.getTruckInPlan(this.$selectedTruck);

      if (this.$selectedTruck && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "$trucks",
    get: function get() {
      return this.$store.getters['milkRun/trucks'];
    },
    set: function set(newVal) {
      this.$setTrucks(newVal);
    }
  }, {
    key: "$bufferTrucks",
    get: function get() {
      return this.$store.getters['milkRun/bufferTrucks'];
    },
    set: function set(newVal) {
      this.$setBufferTrucks(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_ORDERS",
    get: function get() {
      return this.$store.getters['milkRun/GLOBAL_SELECTED_ORDERS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedOrders(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_TRUCKS",
    get: function get() {
      return this.$store.getters['milkRun/GLOBAL_SELECTED_TRUCKS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedTrucks(newVal);
    }
  }, {
    key: "$failedOrders",
    get: function get() {
      return this.$store.getters['milkRun/failedOrders'];
    },
    set: function set(newVal) {
      this.$setFailedOrders(newVal);
    }
  }, {
    key: "$orderColumnTemplates",
    get: function get() {
      return this.$store.getters['milkRun/orderColumnTemplates'];
    },
    set: function set(newVal) {
      this.$setOrderColumnTemplates(newVal);
    }
  }, {
    key: "isManualAssignLoading",
    get: function get() {
      return this.$store.getters['milkRun/isManualAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsManualAssignLoading(newVal);
    }
  }, {
    key: "$isAssignedDriverChanges",
    get: function get() {
      return this.$store.getters['milkRun/isAssignedDriverChanges'];
    },
    set: function set(newVal) {
      this.$setIsAssignedDriverChanges(newVal);
    }
  }, {
    key: "$isUnassignedDriverChanges",
    get: function get() {
      return this.$store.getters['milkRun/isUnassignedDriverChanges'];
    },
    set: function set(newVal) {
      this.$setIsUnassignedDriverChanges(newVal);
    }
  }, {
    key: "$dateRangeOption",
    get: function get() {
      return this.$store.getters['milkRun/dateRangeOption'];
    },
    set: function set(newVal) {
      this.$setDateRangeOption(newVal);
    }
  }, {
    key: "$pagination",
    get: function get() {
      return this.$store.getters['milkRun/pagination'];
    },
    set: function set(newVal) {
      this.$setPagination(newVal);
    }
  }, {
    key: "$dateRange",
    get: function get() {
      return [this.$startDate, this.$endDate];
    },
    set: function set(newVal) {
      if (newVal) {
        this.$setDateRange({
          startDate: newVal[0],
          endDate: newVal[1]
        });
      }
    }
  }, {
    key: "$planDateRange",
    get: function get() {
      return this.$store.getters['milkRun/planDateRange'];
    },
    set: function set(newVal) {
      this.$setPlanDateRange(newVal);
    }
  }, {
    key: "$truckLoading",
    get: function get() {
      return this.$store.getters['milkRun/truckLoading'];
    },
    set: function set(newVal) {
      this.$setTruckLoading(newVal);
    }
  }, {
    key: "$searchType",
    get: function get() {
      return this.$store.getters['milkRun/searchType'];
    },
    set: function set(newVal) {
      this.$setSearchType(newVal);
    }
  }, {
    key: "$selectedTruck",
    get: function get() {
      return this.$store.getters['milkRun/selectedTruck'];
    },
    set: function set(newVal) {
      this.$setSelectedTruck(newVal);
    }
  }, {
    key: "$unassignedOrders",
    get: function get() {
      return this.$store.getters['milkRun/unassignedOrders'];
    },
    set: function set(newVal) {
      this.$setUnassignedOrders(newVal);
    }
  }, {
    key: "$excludedOrders",
    get: function get() {
      return this.$store.getters['milkRun/excludedOrders'];
    },
    set: function set(newVal) {
      this.$setExcludedOrders(newVal);
    }
  }, {
    key: "$includedOrders",
    get: function get() {
      return this.$store.getters['milkRun/includedOrders'];
    },
    set: function set(newVal) {
      this.$setIncludedOrders(newVal);
    }
  }, {
    key: "$selectedOrders",
    get: function get() {
      return this.$store.getters['milkRun/selectedOrders'];
    },
    set: function set(newVal) {
      this.$setSelectedOrders(newVal);
    }
  }, {
    key: "$orderFilters",
    get: function get() {
      return this.$store.getters['milkRun/orderFilters'];
    },
    set: function set(newVal) {
      this.$setOrderFilters(newVal);
    }
  }, {
    key: "$selectedColumns",
    get: function get() {
      return this.$store.getters['milkRun/selectedColumns'];
    },
    set: function set(newVal) {
      this.$setSelectedColumns(newVal);
    }
  }, {
    key: "$selectedDriver",
    get: function get() {
      return this.$store.getters['milkRun/selectedDriver'];
    },
    set: function set(newVal) {
      this.$setSelectedDriver(newVal);
    }
  }, {
    key: "$anyChanges",
    get: function get() {
      return this.$store.getters['milkRun/anyChanges'];
    },
    set: function set(newVal) {
      this.$setAnyChanges(newVal);
    }
  }, {
    key: "$isPlanExists",
    get: function get() {
      return this.$store.getters['milkRun/isPlanExists'];
    },
    set: function set(newVal) {
      this.$setPlanExists(newVal);
    }
  }, {
    key: "locked",
    get: function get() {
      var _this2 = this;

      return this.helper.get(this.helper.filter(this.$trucks, function (truck) {
        return truck['id'] === _this2.$selectedTruck;
      }), '0.locked', true);
    },
    set: function set(newVal) {
      var _this3 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this3.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['locked'] = newVal;
        }

        this.$setPlan({
          'plan': plan
        });
      }
    }
  }, {
    key: "currTruck",
    get: function get() {
      var _this4 = this;

      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === _this4.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "currPlanTruck",
    get: function get() {
      var _this5 = this;

      return this.helper.get(this.$plan.trucks.filter(function (tData) {
        return tData['truckId'] === _this5.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "$truckFilters",
    get: function get() {
      return this.$store.getters['milkRun/truckFilters'];
    },
    set: function set(newVal) {
      this.$setTruckFilters(newVal);
    }
  }, {
    key: "blockedDrivers",
    get: function get() {
      return this.helper.get(this.$userInformation, 'blockedDrivers', []);
    }
  }, {
    key: "routes",
    get: function get() {
      return this.getRoutes(this.$selectedTruck);
    },
    set: function set(newVal) {
      var _this6 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this6.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['routes'] = newVal;
        }

        this.$setPlan({
          'plan': plan
        });
      }
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.routeAPI) {
        this.routeAPI = new _route.RouteAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting
        });
      }

      if (!this.milkRunAPI) {
        this.milkRunAPI = new _milkRun.MilkRunAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting,
          lfToken: this.$lfToken || null
        });
      }

      if (!this.planAPI) {
        this.planAPI = new _plan.PlanAPI({
          userSetting: this.$userSetting,
          lfCustKey: this.$lfCustKey || null,
          lfAPIToken: this.$lfAPIToken || null
        });
      }
    }
  }, {
    key: "getOrders",
    value: function getOrders() {
      var _this7 = this;

      var orderData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';
      var finalOrders = [];

      switch (type) {
        case 'save':
          if (orderData['data'] && orderData['data'].length >= 1) {
            orderData['data'].forEach(function (oData) {
              if (oData['routes'] && oData['routes'].length >= 1) {
                oData['routes'].forEach(function (rData) {
                  var finalOrder = finalOrders.length >= 1 ? finalOrders.find(function (fOrder) {
                    return fOrder['planId'] === rData['planId'];
                  }) : null;

                  if (finalOrder) {
                    finalOrder['orderId'] = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(finalOrder['orderId']), (0, _toConsumableArray2.default)(rData['orderId']))));
                  } else {
                    if (rData['planId'] && rData['orderId']) {
                      finalOrders.push({
                        'planCode': code,
                        'planId': rData['planId'],
                        'orderId': (0, _toConsumableArray2.default)(new Set(rData['orderId']))
                      });
                    }
                  }
                });
              }
            });
          }

          break;

        case 'deleteRoute':
          if (orderData['trucks'] && orderData['trucks'].length >= 1) {
            var orderIds = orderData['trucks'].reduce(function (orderId, oData) {
              if (oData['orderId'].length >= 1 && oData['truckId'] === _this7.$selectedTruck) {
                orderId = [].concat((0, _toConsumableArray2.default)(orderId), (0, _toConsumableArray2.default)(oData['orderId']));
              }

              return orderId;
            }, []);
            finalOrders.push({
              'planCode': '',
              'planId': '',
              'orderId': orderIds
            });
          }

          break;
      }

      if (this.$includedOrders && this.$includedOrders.length >= 1) {
        finalOrders.push({
          'planCode': '',
          'planId': '',
          'orderId': this.$includedOrders
        });
      }

      return finalOrders;
    }
  }, {
    key: "isInvalidOrder",
    value: function isInvalidOrder(order) {
      var bool = false;

      if (order.waypoints && order.waypoints.length >= 2) {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          return true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          return true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'T';
        })) {
          return true;
        }

        if (this.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          return true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0 || parseFloat(order['weight']) === 0 && parseFloat(order['volume']) === 0) {
            bool = true;
          }
        });
      } // else {
      //   bool = true;
      // }


      return bool;
    }
  }, {
    key: "getInvalidOrderDetails",
    value: function getInvalidOrderDetails(order) {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false,
        reason4: false,
        reason5: false,
        reason6: false
      };

      if (order['waypoints'].length < 2) {
        reason.reason1 = true;
      } else {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          reason.reason2 = true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          reason.reason2 = true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'T';
        })) {
          reason.reason2 = true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0) {
            reason.reason3 = true;
          }

          if (parseFloat(order['volume']) === 0) {
            reason.reason4 = true;
          }

          if (parseFloat(order['weight']) === 0) {
            reason.reason5 = true;
          }
        });

        if (this.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          reason.reason6 = true;
        }
      }

      return reason;
    }
  }, {
    key: "getTruckInfo",
    value: function getTruckInfo(truckId) {
      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getTruckInPlan",
    value: function getTruckInPlan(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getDriverInfo",
    value: function getDriverInfo(driverId, fieldName) {
      var driver = this.helper.find(this.$drivers, function (item) {
        return item['RecId'] === driverId;
      });

      if (!this.helper.isUndefined(driver)) {
        return driver[fieldName];
      }

      return null;
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "getTruckPlanIdsByTruckId",
    value: function getTruckPlanIdsByTruckId(truckId) {
      var truck = this.getTruckInPlan(truckId);

      if (truckId && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "getWaypointsFromIds",
    value: function getWaypointsFromIds(waypointIds) {
      var _this8 = this;

      var waypoints = [];
      var orderIds = this.helper.uniq(this.helper.map(waypointIds, function (id) {
        return parseInt(id.split('-')[0], 10);
      }));
      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this8.helper.includes(orderIds, parseInt(order['id'], 10));
      });
      this.helper.forEach(filteredOrders, function (order) {
        _this8.helper.forEach(order['waypoints'], function (waypoint) {
          _this8.helper.forEach(waypointIds, function (wpId) {
            if (waypoint['id'] === wpId) {
              waypoints.push(waypoint);
              return false;
            }
          });
        });
      });
      return filteredOrders.length > 0 ? waypoints : [];
    }
    /**
     * Assuming there are no grouped orders
     * */

  }, {
    key: "getWaypointFromId",
    value: function getWaypointFromId(waypointId, fieldName) {
      var orderId = parseInt(waypointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(waypointId.split('-')[1], 10) || null;

      if (!orderId || !waypointIndex) {
        return null;
      }

      var order = this.$plan['orders'].filter(function (o) {
        return o['id'] === orderId;
      });

      if (!order || order.length === 0) {
        return '';
      }

      var waypoint = this.helper.find(order[0].waypoints, function (wp) {
        return wp.id === waypointId;
      });

      if (!waypoint || waypoint.length === 0) {
        return '';
      }

      return waypoint[fieldName];
    }
  }, {
    key: "getOrderField",
    value: function getOrderField(orderId, fieldName) {
      var selectedOrder = this.helper.get(this.helper.filter(this.$plan['orders'], function (order) {
        return order['id'] === parseInt(orderId, 10);
      }), '0', null);

      if (selectedOrder) {
        return selectedOrder[fieldName];
      }

      return null;
    }
  }, {
    key: "getOrdersField",
    value: function getOrdersField(orderIds, fieldName) {
      var _this9 = this;

      var filteredOrders = this.$plan.orders.filter(function (o) {
        return orderIds.includes(o.id);
      });

      if (this.helper.isUndefined(filteredOrders) || filteredOrders.length === 0) {
        return [];
      }

      return filteredOrders.map(function (o) {
        return o[fieldName];
      }).filter(function (v) {
        return !_this9.helper.isUndefined(v);
      });
    }
  }, {
    key: "manualAssign",
    value: function () {
      var _manualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var res, invalid, message, response, invalidReasons, _message, _message2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.routeAPI.scheduleAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  routes: data['orders'],
                  vehicles: {
                    code: data['truck']['truckId'],
                    zone: data['truck']['zone'],
                    plateNumber: data['truck']['plateNumber'],
                    capacity1: parseFloat(data['truck']['weight']),
                    capacity2: parseFloat(data['truck']['volume']),
                    workingHours: DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: this.$selectedDriver
                  },
                  planIds: data['planIds']
                });

              case 2:
                res = _context.sent;
                invalid = this.helper.get(res, 'data.invalid', []);

                if (!(!(data.truck && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles) && invalid.length === 0)) {
                  _context.next = 8;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context.abrupt("return", null);

              case 8:
                response = res.data;
                invalidReasons = [];

                if (response['invalid'].length > 0) {
                  if (this.helper.isUndefined(response.vehicles) || Object.entries(response.vehicles).length === 0 && response.vehicles.constructor === Object) {
                    _message = {
                      title: this.$i18n.t('planning.messages.failedInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.warning(_message);
                  } else {
                    _message2 = {
                      title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.success(_message2);
                  }

                  response['invalid'].forEach(function (item) {
                    var reason = item['reason'];

                    if (invalidReasons.filter(function (i) {
                      return i['reason'] === reason;
                    }).length === 0) {
                      invalidReasons.push({
                        'reason': reason,
                        'orderId': item.orderId,
                        'shipmentReference': item.shipmentReference
                      });
                    } else {
                      var index = invalidReasons.findIndex(function (i) {
                        return i['reason'] === reason;
                      });

                      if (index !== -1) {
                        invalidReasons[index]['orderId'].push(item.orderId);
                        invalidReasons[index]['shipmentReference'].push(item.shipmentReference);
                      }
                    }
                  });
                }

                return _context.abrupt("return", {
                  invalidReasons: invalidReasons,
                  vehicles: response.vehicles
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function manualAssign(_x) {
        return _manualAssign.apply(this, arguments);
      }

      return manualAssign;
    }()
  }, {
    key: "isValidTruck",
    value: function isValidTruck(truck) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truck['id'];
      }), '0.routes', []).length === 0 && parseFloat(truck['weight']) > 0 && parseFloat(truck['volume']) > 0;
    }
    /*async calculateETA(payload, type?: string) {
      const routes = this.helper.cloneDeep(payload.routes);
      const startTime = type === 'REORDER'
        ? routes[payload.index].startTime
        : this.helper.isUndefined(payload.startTime)
          ? routes[0].startTime
          : payload.startTime;
         const res = await this.routeAPI.calculateETA({
        company: this.$userInformation.company.name,
        code: this.$planDate,
        startDateTime: type === 'REORDER' ? routes[0].startTime : startTime,
        startIndex: type === 'REORDER' ? 0 : payload.index,
        routes: this.formatRoutes(routes, true),
        locked: payload.isLocked
      });
         if (!(res && !res.failed && !this.helper.isUndefined(res.data))) {
        return null;
      }
         this.$anyChanges = true;
      return res.data;
    }*/

  }, {
    key: "isGenerateNewPlanId",
    value: function isGenerateNewPlanId(truckObj) {
      var _this10 = this;

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'unassigned';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this10.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'assigned';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this10.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'assigned';
      }) && this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'unassigned';
      })) {
        var assignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'assigned';
        });
        var unassignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'unassigned';
        });
        return this.helper.every(assignedRoutes, function (r) {
          return !_this10.helper.isUndefined(r.planId);
        }) && this.helper.every(unassignedRoutes, function (r) {
          return _this10.helper.isUndefined(r.planId);
        });
      }

      return false;
    }
  }, {
    key: "savePlan",
    value: function () {
      var _savePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this11 = this;

        var plan,
            isAssign,
            bufferPlan,
            i,
            indexes,
            m,
            prefix,
            newPlanIds,
            orderIds,
            payload,
            saveRes,
            message,
            updateOrderIdsPayload,
            updateOrderRes,
            p,
            data,
            routes,
            groupedRoutesByDriverId,
            res2,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                plan = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : this.$plan;
                isAssign = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                bufferPlan = this.helper.cloneDeep(plan);
                i = 0;
                indexes = [];

                if (!this.$isAssignedDriverChanges) {
                  _context2.next = 9;
                  break;
                }

                m = {
                  title: this.$i18n.t('planning.messages.assignedDriverChanges'),
                  duration: 5000
                };

                _elementUi.Notification.warning(m);

                return _context2.abrupt("return", false);

              case 9:
                this.helper.forEach(bufferPlan['trucks'], function (truck, index) {
                  var isGenerateNewPlanId = _this11.isGenerateNewPlanId(truck);

                  if (isGenerateNewPlanId) {
                    i++;
                    indexes.push(index);
                  }

                  var lastIdxWithPlanId = _this11.helper.findLastIndex(truck.routes, function (route) {
                    return !_this11.helper.isUndefined(route.planId);
                  });

                  var id = lastIdxWithPlanId !== -1 ? truck.routes[lastIdxWithPlanId].planId : null;
                  truck.estimatedDistance = _this11.getRouteDetails(truck.truckId)['estimatedDistance'];
                  truck.estimatedTime = _this11.getRouteDetails(truck.truckId)['estimatedTime'];

                  _this11.helper.forEach(truck['routes'], function (route) {
                    route.isHighlighted = false;

                    if (lastIdxWithPlanId !== -1 && _this11.helper.isUndefined(route.planId) && !isGenerateNewPlanId) {
                      route.planId = id;
                    }
                  });
                }); // const prefix = this.helper.generatePlanId('', this.$userInformation.company.name);

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, '', this.$userInformation, 'milkrun');
                _context2.next = 13;
                return this.routeAPI.generateLoadPlanId(prefix, i);

              case 13:
                newPlanIds = _context2.sent;
                newPlanIds = this.helper.get(newPlanIds, 'data', []);
                this.helper.forEach(indexes, function (value, index) {
                  var id = newPlanIds[index];
                  bufferPlan.trucks[value].routes.forEach(function (route) {
                    if (_this11.helper.isUndefined(route.planId)) {
                      route.planId = id;
                    }
                  });
                  bufferPlan.trucks[value].planId = _this11.helper.uniq(bufferPlan.trucks[value].routes.map(function (x) {
                    return x['planId'];
                  }));
                });
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (truck) {
                  return truck['planId'];
                }));
                orderIds = bufferPlan.orders.map(function (o) {
                  return o.id;
                });
                payload = {
                  user: this.$userInformation.user.name,
                  data: bufferPlan['trucks'].map(function (tData) {
                    delete tData['drivers'];
                    delete tData['orders'];
                    delete tData['trucks'];
                    tData['routes'].map(function (routeData) {
                      delete routeData['orders'];
                      delete routeData['masterpoints'];
                      delete routeData['waypoints'];

                      if (!_this11.helper.isUndefined(routeData.driverId)) {
                        routeData['driverName'] = _this11.getDriverInfo(routeData.driverId, 'UserName');
                      }

                      return routeData;
                    });
                    return tData;
                  })
                };
                _context2.next = 21;
                return this.milkRunAPI.insertPlan(payload);

              case 21:
                saveRes = _context2.sent;
                message = {
                  title: this.$i18n.t('general.updateSuccess'),
                  duration: 5000
                };

                if (saveRes && saveRes.data) {
                  _context2.next = 27;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", false);

              case 27:
                // Hide the assigned order from the table
                updateOrderIdsPayload = {
                  'orders': this.getOrders(payload, this.currentDate, 'save')
                };

                if (!(updateOrderIdsPayload['orders'].length >= 1)) {
                  _context2.next = 36;
                  break;
                }

                _context2.next = 31;
                return this.milkRunAPI.updateOrdersInPlan(updateOrderIdsPayload);

              case 31:
                updateOrderRes = _context2.sent;

                if (updateOrderRes) {
                  _context2.next = 36;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", false);

              case 36:
                bufferPlan['trucks'] = this.helper.cloneDeep(this.helper.get(saveRes, 'data', []));

                if (!(this.$isUnassignedDriverChanges || isAssign)) {
                  _context2.next = 49;
                  break;
                }

                this.helper.forEach(bufferPlan['trucks'], function (t, tIndex) {
                  t.driverId = _this11.$plan.trucks[tIndex]['driverId'].length === 0 ? null : _this11.$plan.trucks[tIndex]['driverId'];

                  _this11.helper.forEach(t.routes, function (r, rIndex) {
                    r.status = plan['trucks'][tIndex]['routes'][rIndex]['status'];
                    r.driverId = plan['trucks'][tIndex]['routes'][rIndex]['driverId'];
                  });
                });
                p = {
                  user: this.$userInformation.user.name,
                  data: []
                };
                data = [];
                routes = this.helper.flatten(bufferPlan['trucks'].map(function (t) {
                  return t['routes'];
                }));
                groupedRoutesByDriverId = this.helper.groupBy(routes, 'driverId');
                this.helper.forEach(groupedRoutesByDriverId, function (val, key) {
                  var groupedRoutesByStatus = _this11.helper.groupBy(val, 'status');

                  _this11.helper.forEach(groupedRoutesByStatus, function (v, k) {
                    data.push({
                      scheduleId: v.map(function (r) {
                        return r._id;
                      }),
                      updatedData: {
                        // zone: v[0].zone,
                        status: v[0].status,
                        driverId: v[0].driverId
                      }
                    });
                  });
                });
                p['data'] = data;
                _context2.next = 47;
                return this.milkRunAPI.updatePlan(p);

              case 47:
                res2 = _context2.sent;
                this.logger.info('Update Driver ID', {
                  p: p
                }, {
                  response: res2
                });

              case 49:
                this.$anyChanges = false;
                this.$isPlanExists = true;
                this.$setPlanExists(true);
                this.$setPlan({
                  'plan': bufferPlan
                });
                this.$failedOrders = [];
                this.$savedOrderIds = this.helper.cloneDeep(orderIds);

                _elementUi.Notification.success(message);

                return _context2.abrupt("return", true);

              case 57:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function savePlan() {
        return _savePlan.apply(this, arguments);
      }

      return savePlan;
    }()
  }, {
    key: "deleteRoutesOrderId",
    value: function () {
      var _deleteRoutesOrderId = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload) {
        var message, orderId, updateOrderIdsPayload, isSomeOrdersAssigned, cancelDriverAssignmentResponse, deleteRes, updateRes, bufferPlan;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                message = {
                  title: this.$i18n.t('general.deleteFailed'),
                  duration: 5000
                };
                orderId = payload.orderId;
                updateOrderIdsPayload = {
                  orders: [{
                    planCode: '',
                    planId: '',
                    orderId: [orderId]
                  }]
                };
                isSomeOrdersAssigned = payload.routes.some(function (route) {
                  return route.status === 'assigned' || route.status === 'completed';
                });

                if (!isSomeOrdersAssigned) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 7;
                return this.cancelDriverAssignment([{
                  shipref: this.getOrderField(orderId, 'shipmentReference')
                }]);

              case 7:
                cancelDriverAssignmentResponse = _context3.sent;

                if (cancelDriverAssignmentResponse) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", false);

              case 10:
                _context3.next = 12;
                return this.milkRunAPI.deleteRoutes({
                  'truckId': payload.routes[0]['truckId'],
                  'scheduleId': payload.routes.map(function (r) {
                    return r._id;
                  })
                });

              case 12:
                deleteRes = _context3.sent;

                if (deleteRes) {
                  _context3.next = 16;
                  break;
                }

                _elementUi.Notification.error(message);

                return _context3.abrupt("return", false);

              case 16:
                if (!(updateOrderIdsPayload['orders'].length >= 1)) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 19;
                return this.milkRunAPI.updateOrdersInPlan(updateOrderIdsPayload);

              case 19:
                updateRes = _context3.sent;

                if (updateRes) {
                  _context3.next = 23;
                  break;
                }

                _elementUi.Notification.error(message);

                return _context3.abrupt("return", false);

              case 23:
                message['title'] = this.$i18n.t('general.deleteSuccess');

                _elementUi.Notification.success(message);

                bufferPlan = this.removeRoutesByOrderId(this.helper.cloneDeep(this.$plan), orderId);
                this.$anyChanges = false;
                this.$isPlanExists = true;
                this.$setPlanExists(true);
                this.$setPlan({
                  'plan': bufferPlan
                });
                this.$resetPlan();

                if (bufferPlan.trucks.length === 0) {
                  this.$setPlan({
                    'isReset': true
                  });
                }

                _context3.next = 34;
                return this.$getUnassignedOrders();

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteRoutesOrderId(_x2) {
        return _deleteRoutesOrderId.apply(this, arguments);
      }

      return deleteRoutesOrderId;
    }()
    /**
     * Assume orderId always has length of 1
     */

  }, {
    key: "removeRoutesByOrderId",
    value: function removeRoutesByOrderId(plan, orderId) {
      var _this12 = this;

      var truckIndex = this.helper.findIndex(plan.trucks, function (truck) {
        return truck['truckId'] === _this12.$selectedTruck;
      });
      var truckObj = plan.trucks[truckIndex];
      var fRoutes = truckObj.routes.filter(function (r) {
        return r['orderId'][0] !== orderId;
      });
      var orderIds = this.helper.uniq(this.helper.flatten(fRoutes.map(function (r) {
        return r['orderId'];
      })));
      var shipRefs = plan.orders.filter(function (o) {
        return orderIds.includes(o.id);
      }).map(function (o) {
        return o.shipmentReference;
      });
      var planIds = this.helper.uniq(fRoutes.map(function (r) {
        return r['planId'];
      }));
      var deletedPlanId = this.helper.uniq(truckObj.routes.filter(function (r) {
        return r['orderId'][0] === orderId;
      }).map(function (r) {
        return r['planId'];
      }))[0];

      if (fRoutes.length > 0) {
        truckObj.driverId = this.helper.uniq(fRoutes.map(function (r) {
          return r['driverId'];
        }));
        truckObj.estimatedDistance = this.helper.sumBy(fRoutes, 'distance');
        truckObj.estimatedTime = this.helper.sumBy(fRoutes, 'time');
        truckObj.orderId = truckObj.orderId.filter(function (o) {
          return !orderIds.includes(o);
        });
        truckObj.shipmentReference = truckObj.shipmentReference.filter(function (o) {
          return !shipRefs.includes(o);
        });
        truckObj.planId = planIds;
        truckObj.routes = fRoutes;
        plan.trucks[truckIndex] = truckObj;
      } else {
        plan.trucks.splice(truckIndex, 1);
      }

      plan.planId = plan.planId.filter(function (id) {
        return id !== deletedPlanId;
      });
      return plan;
    }
  }, {
    key: "getCarPlateFromDriverId",
    value: function getCarPlateFromDriverId(driverId) {
      var driver = this.helper.find(this.$drivers, function (item) {
        return item['RecId'] === driverId;
      });

      if (!this.helper.isUndefined(driver)) {
        return driver['Carplate'];
      }

      return null;
    }
  }, {
    key: "getShipRefsFromOrderId",
    value: function getShipRefsFromOrderId(orderId) {
      var _this13 = this;

      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this13.helper.includes(orderId, parseInt(order['id'], 10));
      });

      if (filteredOrders.length) {
        return this.helper.map(filteredOrders, 'shipmentReference');
      }

      return [];
    }
  }, {
    key: "confirmUnsavedChanges",
    value: function confirmUnsavedChanges(to, from, next) {
      var _this14 = this;

      if (this.$anyChanges && to.name !== 'login') {
        var message = this.$i18n.t('planning.messages.unsavedChanges');

        _elementUi.MessageBox.confirm(message, 'Warning', {
          confirmButtonText: this.$i18n.t('pickColumns.confirm'),
          cancelButtonText: this.$i18n.t('pickColumns.cancel'),
          type: 'warning',
          center: true
        }).then(function () {
          _this14.$anyChanges = false;

          _this14.$resetPlan();

          next();
        }).catch(function () {
          next(false);
        });
      } else {
        this.$resetPlan();
        next();
      }
    }
  }, {
    key: "assignDriver",
    value: function () {
      var _assignDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload) {
        var res, status, response, iOrders;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.planAPI.assignDriver(payload);

              case 2:
                res = _context4.sent;
                status = this.helper.get(res, 'data.status', 300);
                response = {
                  'isSuccess': false,
                  'invalidOrders': null
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context4.next = 9;
                  break;
                }

                iOrders = this.helper.get(res, 'data.errors', []);
                response['invalidOrders'] = iOrders.length ? this.helper.map(iOrders, 'shipref').join(', ') : '-';
                return _context4.abrupt("return", response);

              case 9:
                response['isSuccess'] = true;
                return _context4.abrupt("return", response);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function assignDriver(_x3) {
        return _assignDriver.apply(this, arguments);
      }

      return assignDriver;
    }()
  }, {
    key: "cancelDriverAssignment",
    value: function () {
      var _cancelDriverAssignment = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload) {
        var res, status, error, message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.planAPI.cancelDriverAssignment(payload);

              case 2:
                res = _context5.sent;
                status = this.helper.get(res, 'data.status', 300);
                error = null;
                message = {
                  title: this.$i18n.t('planning.messages.cancelOrdersAssignmentSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context5.next = 11;
                  break;
                }

                error = this.helper.get(res, 'data.error', null);
                message['message'] = "".concat(this.$i18n.t('planning.messages.cancelOrdersAssignmentFailed'), " ").concat(this.$i18n.t('planning.messages.dueTo'), " ").concat(error);

                _elementUi.Notification.error(message);

                return _context5.abrupt("return", false);

              case 11:
                _elementUi.Notification.success(message);

                return _context5.abrupt("return", true);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function cancelDriverAssignment(_x4) {
        return _cancelDriverAssignment.apply(this, arguments);
      }

      return cancelDriverAssignment;
    }()
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      return {
        'pick-up': route['waypointType'] === 'P',
        'drop-off': route['waypointType'] === 'D',
        'action': route['waypointType'] === 'T'
      };
    }
  }, {
    key: "isRouteBelongToDifferentUser",
    value: function isRouteBelongToDifferentUser(route) {
      if (!route.hasOwnProperty('createdUser') && !route.hasOwnProperty('user')) {
        return false;
      }

      if (route.hasOwnProperty('createdUser') && this.$userInformation && this.$userInformation.user) {
        return route['createdUser'] !== this.$userInformation.user.name;
      }

      if (route.hasOwnProperty('user') && this.$userInformation && this.$userInformation.user) {
        return route['user'] !== this.$userInformation.user.name;
      }

      return false;
    }
  }, {
    key: "isSomePlanIdAssigned",
    value: function isSomePlanIdAssigned(planId) {
      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && route.status === 'assigned';
        });
      }

      return false;
    }
  }, {
    key: "isSomePlanIdCompleted",
    value: function isSomePlanIdCompleted(planId) {
      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && route.status === 'completed';
        });
      }

      return false;
    }
  }, {
    key: "isPlanIdBelongToDifferentUser",
    value: function isPlanIdBelongToDifferentUser(planId) {
      var _this15 = this;

      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && _this15.isRouteBelongToDifferentUser(route);
        }) && !isAllowEditOtherUserData;
      }

      return false;
    }
  }, {
    key: "createNewPlanIdRoutes",
    value: function () {
      var _createNewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref) {
        var _this16 = this;

        var planId, truckId, unassignedOrders, isShowFailedOrders, failedOrders, orders, orderIds, message, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                planId = _ref.planId, truckId = _ref.truckId, unassignedOrders = _ref.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = unassignedOrders.filter(function (order) {
                  return !_this16.isInvalidOrder(order);
                });
                orderIds = this.helper.map(orders, 'id');

                if (!(orders.length === 0)) {
                  _context6.next = 9;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context6.abrupt("return", null);

              case 9:
                _context6.next = 11;
                return this.manualAssign({
                  orders: orders,
                  truck: this.getTruckInfo(truckId),
                  planIds: [(0, _defineProperty2.default)({}, planId, orderIds)]
                });

              case 11:
                res = _context6.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context6.next = 17;
                  break;
                }

                return _context6.abrupt("return", null);

              case 17:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context6.next = 21;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context6.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                this.helper.forEach(vehicles.routes, function (r) {
                  // Assume orderId always has length of 1
                  r.new = !_this16.$savedOrderIds.includes(r.orderId[0]);
                });
                return _context6.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createNewPlanIdRoutes(_x5) {
        return _createNewPlanIdRoutes.apply(this, arguments);
      }

      return createNewPlanIdRoutes;
    }()
  }, {
    key: "updateExistingPlanIdRoutes",
    value: function () {
      var _updateExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref3) {
        var _this17 = this;

        var planId, truckObj, unassignedOrders, isShowFailedOrders, failedOrders, indexOccurence, otherRoutes, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                planId = _ref3.planId, truckObj = _ref3.truckObj, unassignedOrders = _ref3.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                indexOccurence = this.helper.findIndex(truckObj['routes'], function (route) {
                  return route.planId === planId;
                });
                otherRoutes = truckObj['routes'].filter(function (route) {
                  return route.planId !== planId;
                });
                selectedOrders = unassignedOrders.filter(function (order) {
                  return !_this17.isInvalidOrder(order);
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = [].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this17.helper.includes(orderIds, order.id);
                });
                orders = [].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders));
                _context7.next = 13;
                return this.manualAssign({
                  orders: orders,
                  truck: this.getTruckInfo(truckObj['truckId']),
                  planIds: [(0, _defineProperty2.default)({}, planId, orderIds)]
                });

              case 13:
                res = _context7.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context7.next = 19;
                  break;
                }

                return _context7.abrupt("return", null);

              case 19:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context7.next = 23;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context7.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                otherRoutes.splice.apply(otherRoutes, [indexOccurence, 0].concat((0, _toConsumableArray2.default)(res['vehicles']['routes'])));
                this.helper.forEach(otherRoutes, function (r) {
                  // Assume orderId always has length of 1
                  r.new = !_this17.$savedOrderIds.includes(r.orderId[0]);
                });
                return _context7.abrupt("return", {
                  truck: _objectSpread(_objectSpread({}, vehicles), {}, {
                    truckId: truckObj['truckId'],
                    locked: false,
                    orderId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(orderIds))).filter(function (order) {
                      return !_this17.helper.includes(invalidOrderIds, order);
                    }),
                    planId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'].planId))),
                    // projectCode: this.helper.uniq([...truckObj['projectCode'], ...res['vehicles'].projectCode]),
                    routes: otherRoutes
                  }),
                  orders: selectedOrders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 27:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateExistingPlanIdRoutes(_x6) {
        return _updateExistingPlanIdRoutes.apply(this, arguments);
      }

      return updateExistingPlanIdRoutes;
    }()
  }, {
    key: "handleNewTruckObj",
    value: function () {
      var _handleNewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(args) {
        var _this18 = this;

        var planId, truckId, unassignedOrders, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                planId = args.planId;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                _context8.next = 5;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders
                });

              case 5:
                res = _context8.sent;

                if (!this.helper.isUndefined(res)) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("return");

              case 8:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 11:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = [].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this18.helper.includes(res.invalidOrderIds, order.id);
                });
                plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  'plan': plan
                });
                _context8.next = 19;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 19:
                this.logger.info('Init Truck: ', truck, 'Plan: ', plan);
                return _context8.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleNewTruckObj(_x7) {
        return _handleNewTruckObj.apply(this, arguments);
      }

      return handleNewTruckObj;
    }()
  }, {
    key: "handleExistingTruckObj",
    value: function () {
      var _handleExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(args) {
        var _this19 = this;

        var planId, isNewPlanId, truckObj, unassignedOrders, truckIndex, res, isShowFailedOrders, failedOrders, truck, plan;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                planId = args.planId;
                isNewPlanId = args.isNewPlanId || true;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                _context9.next = 7;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  truckId: truckObj['truckId'],
                  unassignedOrders: unassignedOrders
                });

              case 7:
                res = _context9.sent;

                if (!this.helper.isUndefined(res)) {
                  _context9.next = 10;
                  break;
                }

                return _context9.abrupt("return");

              case 10:
                isShowFailedOrders = res.isShowFailedOrders;
                failedOrders = res.failedOrders;
                truck = null;

                if (!(this.helper.isUndefined(res['vehicles']) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context9.next = 15;
                  break;
                }

                return _context9.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 15:
                if (isNewPlanId) {
                  truck = _objectSpread(_objectSpread({}, res['vehicles']), {}, {
                    truckId: truckObj['truckId'],
                    locked: false,
                    orderId: [].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(res['orderIds'])).filter(function (order) {
                      return !_this19.helper.includes(res.invalidOrderIds, order);
                    }),
                    planId: [].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'].planId)),
                    projectCode: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['projectCode']), (0, _toConsumableArray2.default)(res['vehicles'].projectCode))),
                    routes: [].concat((0, _toConsumableArray2.default)(truckObj['routes']), (0, _toConsumableArray2.default)(res['vehicles'].routes)),
                    shipmentReference: [].concat((0, _toConsumableArray2.default)(truckObj['shipmentReference']), (0, _toConsumableArray2.default)(res['vehicles'].shipmentReference))
                  });
                } else {
                  truck = res['truck'];
                }

                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(res['orders'])).filter(function (order) {
                  return !_this19.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');

                if (isNewPlanId) {
                  plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                }

                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  'plan': plan
                });
                _context9.next = 23;
                return this.updateOrderTable(res['orderIds'], res['invalidOrderIds'], res['selectedOrderIds']);

              case 23:
                this.logger.info('Update Truck: ', truck, 'Plan: ', plan);
                return _context9.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 25:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function handleExistingTruckObj(_x8) {
        return _handleExistingTruckObj.apply(this, arguments);
      }

      return handleExistingTruckObj;
    }()
  }, {
    key: "updateOrderTable",
    value: function () {
      var _updateOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(orderIds, invalidOrderIds, selectedOrderIds) {
        var _this20 = this;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.$selectedOrders = [];
                this.$excludedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$excludedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return !_this20.helper.includes(invalidOrderIds, oId);
                }))));
                this.$includedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return _this20.helper.includes(invalidOrderIds, oId);
                }))).filter(function (oId) {
                  return !_this20.helper.includes(selectedOrderIds, oId);
                }));
                _context10.next = 5;
                return this.$getUnassignedOrders();

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateOrderTable(_x9, _x10, _x11) {
        return _updateOrderTable.apply(this, arguments);
      }

      return updateOrderTable;
    }()
  }, {
    key: "getRouteDetails",
    value: function getRouteDetails(truckId) {
      var truck = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truckId;
      }), '0', null);

      if (!truck) {
        return {
          estimatedDistance: 0,
          estimatedTravellingTime: 0
        };
      }

      if (truck && truck.routes && truck.routes.length > 0) {
        return {
          estimatedDistance: this.helper.sumBy(truck.routes, 'distance') || 0,
          estimatedTravellingTime: this.helper.sumBy(truck.routes, 'time') || 0
        };
      }

      return {
        estimatedDistance: 0,
        estimatedTravellingTime: 0
      };
    }
  }, {
    key: "isOrderIdExistInGlobal",
    value: function isOrderIdExistInGlobal(orderId) {
      var _this21 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this21.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalOrderInfo",
    value: function getGlobalOrderInfo(orderId, fieldName) {
      var _this22 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this22.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isTruckIdExistInGlobal",
    value: function isTruckIdExistInGlobal(truckId) {
      var _this23 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this23.$userInformation && _this23.$userInformation.user && o.userId !== _this23.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalTruckInfo",
    value: function getGlobalTruckInfo(truckId, fieldName) {
      var _this24 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this24.$userInformation && _this24.$userInformation.user && o.userId !== _this24.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }]);
  return MilkRunMixin;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin));

exports.MilkRunMixin = MilkRunMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfCustKey', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$lfCustKey", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfAPIToken', {
  namespace: 'authentication'
})], MilkRunMixin.prototype, "$lfAPIToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('drivers', {
  namespace: 'common'
})], MilkRunMixin.prototype, "$drivers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('plan', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$plan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultPagination', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$defaultPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('startDate', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$startDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('endDate', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$endDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultOrderColumns', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$defaultOrderColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('tableLoading', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$tableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultLocationType', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$defaultLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], MilkRunMixin.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE_RANGE', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setPlanDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DATE_RANGE_OPTION', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setDateRangeOption", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TABLE_LOADING', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setTableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_EXCLUDED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setExcludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_INCLUDED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setIncludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_DRIVER', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSelectedDriver", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCK', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSelectedTruck", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_LOADING', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setTruckLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCKS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_BUFFER_TRUCKS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setBufferTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ANY_CHANGES', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setAnyChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_EXISTS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setPlanExists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PAGINATION', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_FILTERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setOrderFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_COLUMNS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSelectedColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_FILTERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setTruckFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_UNASSIGNED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_LOCATION_TYPE', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SEARCH_TYPE', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSearchType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SAVED_ORDER_IDS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setSavedOrderIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MANUAL_ASSIGN_LOADING', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setIsManualAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ASSIGNED_DRIVER_CHANGES', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setIsAssignedDriverChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_UNASSIGNED_DRIVER_CHANGES', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setIsUnassignedDriverChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_FAILED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setFailedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_COLUMN_TEMPLATES', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setOrderColumnTemplates", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_ORDERS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setGlobalSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_TRUCKS', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setGlobalSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$resetPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('initPlan', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$initPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setPlan', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getUnassignedOrders', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$getUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setDateRange', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$setDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getTrucks', {
  namespace: 'milkRun'
})], MilkRunMixin.prototype, "$getTrucks", void 0);
exports.MilkRunMixin = MilkRunMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], MilkRunMixin);